import { registerComponent, hasBlankSelectedOption } from "helpers";
import WYATTElement from "wyatt";

registerComponent(
  "product-name-and-number",
  class ProductNameAndNumber extends WYATTElement {
    constructor() {
      super();

      this.toggle = this.querySelector("[data-toggle]");
      this.deactivate();

      this.toggle.addEventListener(
        "change",
        this.handleToggleChange.bind(this),
      );

      this.subscribe(WYATT.PubSub.events.updateOption, this.update.bind(this));

      this.update();
    }

    update() {
      this.syncBlankVisibility(
        hasBlankSelectedOption(
          this.config.blankOptions,
          this.config.blankValues,
        ),
      );
      this.publishPersonalization();
    }

    syncBlankVisibility(isBlank) {
      if (isBlank) {
        this.hidden = true;
        this.toggle.checked = false;
        this.deactivate();
        return;
      }

      this.hidden = false;
    }

    handleToggleChange(event) {
      if (event.target.checked) {
        this.activate();
      } else {
        this.deactivate();
      }
    }

    activate() {
      this.setAttribute("data-expanded", "true");
      this.publishPersonalization();
    }

    deactivate() {
      this.setAttribute("data-expanded", "false");
      this.publishPersonalization();
    }

    getPersonalizationState() {
      return this.toggle.checked;
    }

    publishPersonalization() {
      this.publish(WYATT.PubSub.events.updatePersonalization, {
        enabled: this.toggle.checked,
      });
    }
  },
);
